module.exports = {
    created () {
        this.$eventHub.$on('wpr_updatePlugin', this.updatePlugin);
        this.$eventHub.$on('wpr_updateAllPlugins', this.updateAllPlugins);
        this.$eventHub.$on('wpr_updatePluginList', this.updatePluginList);
        this.$eventHub.$on('wpr_updateSitePlugins', this.updateSitePlugins);
        this.$eventHub.$on('WPR_Update_notif', this.handleResponse);
        this.$eventHub.$on('checkUpdating', this.checkUpdating);
        if (typeof window.wpr_loaded !== 'undefined') {
            // this.checkExisting(false);
        }
    },
    data() {
        return {
            plugins: false,//window.collect([]),
            checkingKeys: false,
            oldUpdates: [],
            theExisting: false,
            bootin: true
        }
    },
    methods: {
        /**
         * Find all the existing WP Remote updates running and then set them to loading
         */
        checkExisting(site_id)
        {
            let url = '/api/wpremote/findUpdates';
            if (site_id) {
                url += '/' + site_id;
            }
            this.axios.get(url).then((response) => {
                this.bootin = false;
                if ( ! response.data.length) return;
                if (site_id) {
                    this.theExisting = response.data;
                }
                this.setLoading(response.data);
            }).catch((errors) => {
                // thow errors
                fyi(errors);
                myAlert('There was an error with that request.');
                this.bootin = false;
            });
        },
        /**
         * Set Loading for a list a plugins
         *
         * @param plugins
         */
        setLoading(plugins)
        {
            $.each(plugins, (key, plugin) => {
                let thePlugin = this.findPlugin(plugin.site_id, plugin.slug);
                if (thePlugin) {
                    thePlugin.isLoading( 1 );
                }
            });
        },
        /**
         * Check site for updating plugins
         *
         * @param site_id
         */
        checkUpdating(site_id)
        {
            if (this.bootin) return; // No Need, we are already checking this shit
            if (this.theExisting) { // basically a cache for the first load and sites start refreshing
                this.setLoading(this.theExisting);
                return;
            }
            this.checkExisting(site_id);
            this.theExisting = false;
        },
        /**
         * Handle the update notification data
         *
         * @param data
         */
        handleResponse(data)
        {
            this.theExisting = false;
            if (typeof data['type'] !== 'undefined' && data.type === 'plugin') {
                let plugin = this.findPlugin(data.site_id, data.slug);
                if (!plugin) {
                    fyi('NO PLUGIN YO');
                    return;
                }
                // Reset plugin statuses
                plugin.updateErrored( false );
                plugin.updateWarning( false );

                if (data.status === 'not-found') {
                    plugin.updateWarning( true );
                    plugin.updateWarningMessage(data.msg);
                    this.addOldUpdate(plugin);
                    return;
                }
                
                if (data.status === 'error') {
                    plugin.isLoading( 0 );
                    plugin.updateErrored( true );
                    if (data.stop) {
                        plugin.updateErrorMessage('Updating plugin failed.');
                        ErrorReporter.throwError('Fatal Error: ' + data.msg);
                        this.stopAllSiteUpdates(data.site_id);
                        return;
                    }
                    plugin.updateErrorMessage(data.msg);
                    return;
                }
                if (data.status === 'warning') {
                    plugin.updateWarning( true );
                    plugin.updateWarningMessage(data.msg);
                    return;
                }

                if ( plugin.name() === "WP Remote" )
                    plugin.site().refresh();

                plugin.completeUpdate();
            }
        },
        /**
         * Update plugin individually
         * @param plugin
         */
        updatePlugin(plugin) {
            let lePlugin = this.preparePlugin(plugin);
            if (lePlugin) {
                this.doUpdate([ lePlugin ]);
                return;
            }
            fyi('lePlugin update failed');
        },
        /**
         * Update All Plugins
         */
        updateAllPlugins()
        {
            let _plugins = [];
            let lePlugin = false;
            ko.utils.arrayForEach( SitesController.sites(), ( site ) => {
                ko.utils.arrayForEach( site.plugins(), ( plugin ) => {
                    lePlugin = this.preparePlugin(plugin);
                    if (lePlugin) {
                        _plugins.push(lePlugin);
                    }
                } );
            } );
            this.doUpdate(_plugins);
        },
        /**
         * Update all plugins passed
         *
         * @param plugins
         */
        updatePluginList(plugins)
        {
            let _plugins = [];
            let lePlugin = false;
            ko.utils.arrayForEach( plugins, ( plugin ) => {
                lePlugin = this.preparePlugin(plugin);
                if (lePlugin) {
                    _plugins.push(lePlugin);
                }
            } );
            this.doUpdate(_plugins);
        },
        /**
         * Update all plugins for one site
         *
         * @param site
         */
        updateSitePlugins(site)
        {
            let _plugins = [];
            let lePlugin = false;
            ko.utils.arrayForEach( site.plugins(), ( plugin ) => {
                lePlugin = this.preparePlugin(plugin);
                if (lePlugin) {
                    _plugins.push(lePlugin);
                }
            } );
            this.doUpdate(_plugins);
        },
        /**
         * Prepare Plugin for Request
         *
         * @param plugin
         * @returns {*}
         */
        preparePlugin(plugin)
        {
            if ( plugin.isUpdateAvailable() && ! plugin.isLocked() ) {
                plugin.isLoading( 1 );
                plugin.updateErrored( false );
                plugin.updateWarning( false );

                return {
                    type: 'plugin',
                    // name: plugin.name(),
                    slug: plugin.slug(),
                    site_id: plugin.site().id(),
                    active: plugin.isActive()
                };
            }
            return false;
        },
        /**
         * Send the requested updates to the queue
         *
         * @param updates
         */
        doUpdate(updates)
        {
            this.axios.post('/api/wpremote/doUpdate', {
                updates: updates
            }).catch((errors) => {
                // thow errors
                myAlert('There was an error with that request.');
                this.stopAllSiteUpdates();
            });
        },
        /**
         * Find a plugin's ko js counterpart
         *
         * @param site_id
         * @param slug
         */
        findPlugin(site_id, slug)
        {
            let site = SitesController.siteForID(site_id);
            if (site) {
                return site.findPluginBySlug(slug);
            }
            return false;
        },
        /**
         * Add old update to queue
         * @param plugin
         */
        addOldUpdate(plugin)
        {
            this.oldUpdates.push(plugin);
            if ( this.oldUpdates.length === 1 ) {
                this.runOldUpdates();
            }
        },
        /**
         * Run Old Updates
         */
        runOldUpdates()
        {
            if ( ! this.oldUpdates.length ) return; // Finished updates
            this.oldUpdates[0].oldUpdate( this.validateOldPlugins() );
        },
        /**
         *
         */
        validateOldPlugins()
        {
            let plugin = this.oldUpdates.shift(); // Fetch first plugin and remove it
            // TODO : check previous active status vs new
            this.runOldUpdates();
        },
        /**
         * Stop the spinner for all of a site's plugins
         *
         * @param site_id
         */
        stopAllSiteUpdates(site_id) {
            if (typeof site_id === 'undefined') {
                ko.utils.arrayForEach( SitesController.sites(), function( site ) {
                    this.stopAllSiteUpdates(site.id());
                });
                return;
            }
            let site = SitesController.siteForID(site_id);
            ko.utils.arrayForEach( site.plugins(), function( plugin ) {
                plugin.isLoading( 0 );
            } );
        },
    },
    // It's good to clean up event listeners before a component is destroyed.
    beforeDestroy () {
        this.$eventHub.$off('WPR_doUpdate', this.doUpdate);
    }
};